<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 11:02:08
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:47:25
 * @name: 审核人员通过
 * @Description: 审核人员通过
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\dialog\approve-resolve.vue
 * @Author: desktop
-->
<template>
  <addNeditDialog
    ref="addNeditDialog"
    title="审批通过"
    bar-title="基本信息"
    @close="close"
  >
    <template v-slot:form>
      <div class="row">
        <div class="label">姓名</div>
        <div class="value">
          <font>{{ info.realname }}</font>
        </div>
      </div>
      <div class="row">
        <div class="label">电话</div>
        <div class="value">
          <font>{{ info.mobile }}</font>
        </div>
      </div>
      <div class="row">
        <div class="label">所属部门</div>
        <div class="value">
          <el-select
            class="input"
            v-model="department_id"
            placeholder="请选择所属部门"
          >
            <el-option
              v-for="item of parents"
              :key="item.id"
              :label="item.department_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="label">职位</div>
        <div class="value">
          <el-select class="input" v-model="role_id" placeholder="请选择职位">
            <el-option
              v-for="(value, key) in roles"
              :key="key"
              :label="value"
              :value="key"
            ></el-option>
          </el-select>
        </div>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="confirm">确认</el-button>
      <el-button plain @click="cancel">取消</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import addNeditDialog from "./addNeditDialog";
import { debounceation } from "@/utils/decorator";
export default {
  components: {
    addNeditDialog,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      info: {},
      department_id: "",
      parents: [], //部门列表
      roles: {}, //职位类数组对象
      role_id: "", //选中的职位id
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} row 行数据
     */
    open(row) {
      this.info = row;
      let { all, me } = this.mailList.getAllNodeNnow(); //获取所有部门及当前部门
      this.parents = all.filter((x) => x.level > 1);
      this.getRoleList(); //获取职位列表
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取职位列表
     */
    getRoleList() {
      this.mailList
        .getRoleList()
        .then((res) => {
          this.roles = res.data;
        })
        .catch(() => {});
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化
     */
    close() {
      this.info = {};
      this.department_id = "";
      this.parents = [];
      this.role_id = "";
      this.roles = [];
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    confirm() {
      this.$emit("approveResolveHandler", {
        ...this.info,
        department_id: this.department_id,
        role_id: this.role_id,
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击取消
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.row {
  margin-bottom: 20px;
  width: 400px;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .value {
    flex: 1;
    font {
      font-size: $Vars-font-content-size;
    }
    .input {
      width: 100%;
    }
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>